"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultTheme = {
  bubble: {
    strokeWidth: 1,
    stroke: "#000",
    fill: "none",
    fillOpacity: 1
  },
  highlightBubble: {
    stroke: "#f00",
    strokeWidth: 2,
    fill: "#f004"
  },
  highlightLine: {
    stroke: "#f00"
  },
  highlightText: {
    fill: "#f00"
  },
  text: {
    fontSize: 12,
    fill: "#000",
    textAnchor: "start",
    alignmentBaseline: "central"
  },
  line: {
    stroke: "#000",
    strokeWidth: 1
  }
};
/**
 * Returns the Y position for the annotation on a bubble
 */

var getAnnotationPosition = function getAnnotationPosition(sizes, currentSize) {
  var sorted = sizes.slice().sort(function (a, b) {
    return a - b;
  });
  var currentIndex = sorted.findIndex(function (s) {
    return s === currentSize;
  });
  var previousHeight = currentIndex === 0 ? 0 : sizes[currentIndex - 1] * 2;
  var currentHeight = currentSize * 2;
  return (currentHeight - previousHeight) / 2 + previousHeight;
};
/**
 * Renders a collection of bubbles with annotations
 */


var BubbleScale = function BubbleScale(_ref) {
  var _ref$sizes = _ref.sizes,
      sizes = _ref$sizes === void 0 ? [4, 12, 20] : _ref$sizes,
      _ref$extent = _ref.extent,
      extent = _ref$extent === void 0 ? [0, 1] : _ref$extent,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? [1, 48, 1, 1] : _ref$margin,
      _ref$lineLength = _ref.lineLength,
      lineLength = _ref$lineLength === void 0 ? 16 : _ref$lineLength,
      highlight = _ref.highlight,
      _ref$formatLabel = _ref.formatLabel,
      formatLabel = _ref$formatLabel === void 0 ? function (d) {
    return d;
  } : _ref$formatLabel,
      _ref$theme = _ref.theme,
      providedTheme = _ref$theme === void 0 ? {} : _ref$theme,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["sizes", "extent", "margin", "lineLength", "highlight", "formatLabel", "theme", "children"]);

  var theme = (0, _deepmerge["default"])(defaultTheme, providedTheme);
  var mx = margin[1] + margin[3];
  var my = margin[0] + margin[2];
  var maxRadius = sizes[sizes.length - 1];
  var width = maxRadius * 2 + lineLength;
  var height = maxRadius * 2;
  var scale = (0, _utils.getPositionScale)("linear", sizes, extent, {
    nice: true
  });
  var highlightYPos = highlight && height - getAnnotationPosition([scale.invert(highlight)], scale.invert(highlight));
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width + mx,
    height: height + my,
    className: (0, _clsx["default"])("BubbleScale", {
      "BubbleScale--highlighted": highlight
    })
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    className: "BubbleScale__bubbles",
    transform: "translate(".concat(margin[3], ",").concat(margin[0], ")")
  }, sizes.slice().reverse().map(function (s, i) {
    var yPos = height - getAnnotationPosition(sizes, s);
    return /*#__PURE__*/_react["default"].createElement("g", {
      key: s
    }, /*#__PURE__*/_react["default"].createElement("circle", _extends({
      cx: maxRadius,
      cy: height - s,
      r: s
    }, theme.bubble)), !highlight && /*#__PURE__*/_react["default"].createElement("line", _extends({
      x1: maxRadius,
      x2: maxRadius * 2 + lineLength,
      y1: yPos,
      y2: yPos
    }, theme.line)), !highlight && /*#__PURE__*/_react["default"].createElement("text", _extends({
      x: maxRadius * 2 + lineLength + 8,
      y: yPos
    }, theme.text), formatLabel(scale(s))));
  })), highlight && /*#__PURE__*/_react["default"].createElement("g", {
    className: "BubbleScale__highlight",
    transform: "translate(".concat(margin[3], ",").concat(margin[0], ")")
  }, /*#__PURE__*/_react["default"].createElement("circle", _extends({
    cx: maxRadius,
    cy: height - scale.invert(highlight),
    r: scale.invert(highlight)
  }, theme.bubble, theme.highlightBubble)), /*#__PURE__*/_react["default"].createElement("line", _extends({
    x1: maxRadius,
    x2: maxRadius * 2 + lineLength,
    y1: highlightYPos,
    y2: highlightYPos
  }, theme.line, theme.highlightLine)), /*#__PURE__*/_react["default"].createElement("text", _extends({
    x: maxRadius * 2 + lineLength + 8,
    y: highlightYPos
  }, theme.text, theme.highlightText), formatLabel(highlight))), children);
};

BubbleScale.propTypes = {
  /** Array of numbers corresponding to bubble radii */
  sizes: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** extent of the data values that correspond to bubbles */
  extent: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** margins to apply around the bubble scale */
  margin: _propTypes["default"].arrayOf(_propTypes["default"].number),

  /** length the line extends outside of the bubble */
  lineLength: _propTypes["default"].number,

  /** formatter function for labels */
  formatLabel: _propTypes["default"].func,

  /** when provided, adds a overlay bubble with the provided value */
  highlight: _propTypes["default"].number,

  /** theme object that passes props to child elements */
  theme: _propTypes["default"].shape({
    bubble: _propTypes["default"].object,
    line: _propTypes["default"].object,
    text: _propTypes["default"].object
  })
};
BubbleScale.__docgenInfo = {
  "description": "Renders a collection of bubbles with annotations",
  "methods": [],
  "displayName": "BubbleScale",
  "props": {
    "sizes": {
      "defaultValue": {
        "value": "[4, 12, 20]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false,
      "description": "Array of numbers corresponding to bubble radii"
    },
    "extent": {
      "defaultValue": {
        "value": "[0, 1]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false,
      "description": "extent of the data values that correspond to bubbles"
    },
    "margin": {
      "defaultValue": {
        "value": "[1, 48, 1, 1]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "number"
        }
      },
      "required": false,
      "description": "margins to apply around the bubble scale"
    },
    "lineLength": {
      "defaultValue": {
        "value": "16",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "length the line extends outside of the bubble"
    },
    "formatLabel": {
      "defaultValue": {
        "value": "(d) => d",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "formatter function for labels"
    },
    "theme": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "bubble": {
            "name": "object",
            "required": false
          },
          "line": {
            "name": "object",
            "required": false
          },
          "text": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": "theme object that passes props to child elements"
    },
    "highlight": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "when provided, adds a overlay bubble with the provided value"
    }
  }
};
var _default = BubbleScale;
exports["default"] = _default;